/*
 * Cart drawer: promo code + "Benefits applied" toggles.
 *
 * Codes are applied through the native Cart AJAX API (POST /cart/update.js with { discount: "CODE1,CODE2" }),
 * so they are the same Shopify discount codes used at checkout and they carry over to it.
 * Open/expanded/error state is kept as classes on the <cart-drawer> root because the drawer HTML is replaced
 * on every cart update; the markup (see snippets/lh-cart-summary.liquid) reads those classes from CSS.
 */
(function () {
  var OPEN = 'lh-promo-open';
  var ERROR = 'lh-promo-error';
  var BENEFITS = 'lh-benefits-open';
  var BUSY = 'lh-promo-busy';
  var SOURCE = 'lh-cart-promo';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function appliedCodes() {
    return Array.prototype.map.call(document.querySelectorAll('[data-lh-promo-code]'), function (el) {
      return el.getAttribute('data-lh-promo-code');
    });
  }

  // Keeps aria-expanded and the typed code in sync after the drawer HTML is replaced.
  function syncUi() {
    var root = drawer();
    if (!root) return;

    var promoToggle = root.querySelector('[data-lh-promo-toggle]');
    if (promoToggle) promoToggle.setAttribute('aria-expanded', String(root.classList.contains(OPEN)));

    var benefitsToggle = root.querySelector('[data-lh-benefits-toggle]');
    if (benefitsToggle) benefitsToggle.setAttribute('aria-expanded', String(root.classList.contains(BENEFITS)));

    var input = root.querySelector('.lh-promo__input');
    if (input && root.dataset.lhPromoValue && !input.value) input.value = root.dataset.lhPromoValue;
  }

  function updateDiscount(codes) {
    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    }).then(function (res) {
      return res.json();
    });
  }

  // Same refresh path as any other cart change: subscribers re-render the drawer (and the cart page).
  function refresh(cart) {
    return publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cart });
  }

  function apply(rawCode) {
    var root = drawer();
    var code = (rawCode || '').trim();
    if (!root || !code) return Promise.resolve();

    var previous = appliedCodes();
    var upper = code.toUpperCase();
    if (
      previous.some(function (c) {
        return c.toUpperCase() === upper;
      })
    ) {
      return Promise.resolve();
    }

    root.classList.add(BUSY);
    root.classList.remove(ERROR);
    root.dataset.lhPromoValue = code;

    return updateDiscount(previous.concat([code]))
      .then(refresh)
      .then(function () {
        var applied = appliedCodes().some(function (c) {
          return c.toUpperCase() === upper;
        });

        if (applied) {
          root.classList.remove(OPEN, ERROR);
          delete root.dataset.lhPromoValue;
          return;
        }

        // Not applicable: show the error and take the rejected code back out of the cart so it can't
        // linger into checkout.
        root.classList.add(OPEN, ERROR);
        return updateDiscount(previous).then(refresh);
      })
      .catch(function (error) {
        console.error('[lh-cart-promo]', error);
        root.classList.add(OPEN, ERROR);
      })
      .then(function () {
        root.classList.remove(BUSY);
        syncUi();
      });
  }

  function remove(code) {
    var root = drawer();
    if (!root) return Promise.resolve();

    var rest = appliedCodes().filter(function (c) {
      return c !== code;
    });

    root.classList.add(BUSY);
    return updateDiscount(rest)
      .then(refresh)
      .catch(function (error) {
        console.error('[lh-cart-promo]', error);
      })
      .then(function () {
        root.classList.remove(BUSY);
      });
  }

  document.addEventListener('click', function (event) {
    var root = drawer();
    if (!root || !event.target.closest) return;

    var promoToggle = event.target.closest('[data-lh-promo-toggle]');
    if (promoToggle) {
      var opening = !root.classList.contains(OPEN);
      root.classList.toggle(OPEN, opening);
      if (!opening) {
        root.classList.remove(ERROR);
        delete root.dataset.lhPromoValue;
      }
      syncUi();
      if (opening) {
        var input = root.querySelector('.lh-promo__input');
        if (input) input.focus();
      }
      return;
    }

    if (event.target.closest('[data-lh-benefits-toggle]')) {
      root.classList.toggle(BENEFITS);
      syncUi();
      return;
    }

    var removeButton = event.target.closest('[data-lh-promo-remove]');
    if (removeButton) {
      event.preventDefault();
      remove(removeButton.getAttribute('data-lh-promo-remove'));
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-lh-promo-form]');
    if (!form) return;
    event.preventDefault();
    apply(form.querySelector('.lh-promo__input').value);
  });

  // Typing clears the error state.
  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('.lh-promo__input');
    var root = drawer();
    if (!input || !root) return;
    root.classList.remove(ERROR);
    root.dataset.lhPromoValue = input.value;
  });

  document.addEventListener('DOMContentLoaded', function () {
    var root = drawer();
    if (!root) return;
    new MutationObserver(syncUi).observe(root, { childList: true, subtree: true });
    syncUi();
  });
})();
